import { Link } from "@inertiajs/react"
import { Image } from "lucide-react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { Button } from "@/components/ui/button"
import { missionsPath } from "@/routes"

/**
 * OKS-39 — Brand-empty state (UX Spec §2 / PRD OQ-8).
 *
 * Renders when `is_empty=true` (the brand has zero approved submissions
 * EVER, regardless of filters). Aspirational copy + CTA back to
 * `/brand/missions` so the operator goes seed content. Filter row is
 * hidden by the parent in this branch — there's nothing to filter.
 */
export function GalleryEmptyState() {
  const { t } = useTranslation()

  return (
    <EmptyState
      icon={Image}
      title={t("content_gallery.empty.title")}
      description={t("content_gallery.empty.helper")}
      actions={
        <Button asChild data-testid="gallery-empty-cta">
          <Link href={missionsPath()}>{t("content_gallery.empty.cta")}</Link>
        </Button>
      }
    />
  )
}
